import { createActionFactory } from '../../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Common Entities => Winner => ');

const fetchWinnersHistory = createAction('fetch winner historys', (experienceId) => ({ experienceId }));
const fetchWinnersHistorySuccess = createAction('fetch winner historys success', (winnerHistorys) => ({
  winnerHistorys,
}));
const fetchWinnersHistoryFailure = createApiFailureAction('fetch winner historys failure');

export default {
  fetchWinnersHistory,
  fetchWinnersHistorySuccess,
  fetchWinnersHistoryFailure,
};
